
import PropTypes from 'prop-types'
import { Toolbar } from '@mui/material'
import { Brand } from 'frame/components'
import Box from '@mui/material/Box'

const FBTWebFormLayout = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        height: '100%',
        width: '100%',
        overflowX: 'hidden',
        minHeight: '100vh',
        position: 'relative',
        '&::before': {
          content: '" "',
          position: 'absolute',
          zIndex: -99,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundImage: 'url(\'/static/images/backgrounds/bg1.png\')',
          backgroundSize: '100vw 100vh',
          backgroundPosition: 'left top',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        },
      }}>
      <Toolbar
        sx={{
          flex: 1,
          minHeight: 74,
          background: 'linear-gradient(0.25turn, #022946, #01B6B1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        position="static">
        <Brand variant="light" />
      </Toolbar>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        {children}
      </Box>
    </Box>
  )
}

FBTWebFormLayout.propTypes = {
  children: PropTypes.any,

}
export default FBTWebFormLayout
